import apiClient from "@/services/ApiClient.js";
import MotifData from "@/objects/MotifData.js";

export default {
  getCustomMotif(cmRequest) {
    return apiClient.get("/custommotifs", {
      params: {
        cmRequest: cmRequest,
      },
    });
  },
};
